<!-- Formulario para añadir nuevo mensaje -->
<div class="message-form mt-4" id="add-message" animate.enter="loaded-fade-enter">
  <div class="container px-0">
    <div class="message-form-header">
      <h4>Añadir mensaje</h4>
      <div class="header-actions">
        <button type="button" *ngIf="isAdmin" (click)="openTemplateModal()" class="btn btn-outline-secondary btn-sm me-2">
          <i class="fa-solid fa-file-lines"></i> Seleccionar template
        </button>
        <button type="button" (click)="fixAddMessageToBottom()" class="btn-close"><span class="visually-hidden">Cerrar</span></button>
      </div>
    </div>
    <div class="form-group mb-3">
      <angular-editor [config]="editorConfig" [(ngModel)]="newMessage"></angular-editor>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="form-group">
          <label class="form-label mb-1">Archivo adjunto</label>
          <ngx-dropzone class="rounded-0 mb-sm-2" id="dzFileAttached" (change)="onFileAttachedSelect($event)" [multiple]="false">
            <ngx-dropzone-label class="bg-cropper_label">
              Arrastra o selecciona el archivo
            </ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of fileAttachedFiles" [file]="f" [removable]="true" (removed)="onFileAttachedRemove(f)">
              <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        @if (isAdmin) {
        <div class="cont_switches justify-end mb-3 me-3">
          <div class="cont__switch-group">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="isInternalCheck" [(ngModel)]="isInternal" [disabled]="sendingMessage">
              <label class="form-check-label" for="isInternalCheck">Mensaje Interno</label>
            </div>
            @if (isInternal) {
            <small class="form-text text-muted" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
              Los mensajes internos solo son visibles para los administradores y gestores.
            </small>
            }
          </div>
        </div>
        }
      </div>
    </div>
    <div class="text-end">
      <button type="button" [ngClass]="{'btn-lead': isAdmin,'btn btn-primary': !isAdmin}" (click)="sendMessage()" [disabled]="sendingMessage || !newMessage || newMessage.trim() === ''">
        @if (sendingMessage) {
        <i class="fa-solid fa-spinner fa-spin"></i> Enviando...
        } @else {
        <i class="fa-solid fa-paper-plane"></i> Enviar Mensaje
        }
      </button>
    </div>

    @if (isAdmin && incidence?.CanViewItResponse) {
    <div class="form-group mt-3 it-response-form">
      <label class="form-label mb-1">Respuesta IT</label>
      <textarea class="form-control" rows="6" placeholder="Respuesta interna del equipo IT..." [(ngModel)]="itResponseDraft" [disabled]="!incidence?.CanEditItResponse || savingItResponse"></textarea>
      @if (incidence?.ItResponse) {
      <small class="form-text text-muted">Última actualización por {{ incidence?.ItResponseUserName }} el {{ incidence?.ItResponseDate }}</small>
      }
      @if (incidence?.CanEditItResponse) {
      <div class="text-end mt-2">
        <button type="button" class="btn-lead" (click)="saveItResponse()" [disabled]="savingItResponse">
          @if (savingItResponse) {
          <i class="fa-solid fa-spinner fa-spin"></i> Guardando...
          } @else {
          <i class="fa-solid fa-save"></i> Guardar
          }
        </button>
      </div>
      }
    </div>
    }
  </div>
</div>
